import ArenaSeat from './arena-seat';
import ArenaTariff from './arena-tariff';

export default class ArenaSeatsList {
    Places: Array<ArenaSeat> = [];
    Tariffs: Array<ArenaTariff> = [];
}